import { atomWithStorage } from "jotai/utils";

export interface AdminUserProfile {
  AdminUserHasChangePassword: boolean;
  FirstName: string;
  Id: string;
//   Role: string;
  RoleIds: Array<string>;
  RoleNames: Array<string>;
  Token: string;
  UserName: string;
  expiryDate: string;
  Permissions: Array<string>
}

export const tokenAtom = atomWithStorage("token", "");

const defaultUser = localStorage.getItem("e-voting-admin-user");
export const userAtom = atomWithStorage<AdminUserProfile | undefined>("e-voting-admin-user", JSON.parse(defaultUser!) ?? undefined);

export const subSideBarAtom = atomWithStorage("show-sub-sidebar", false);

// {
//   Token: "",
//   UserName: "",
//   Id: "",
//   expiryDate: "",
//   Role: null,
//   AdminUserHasChangePassword: true,
//   FirstName: "",
//   Message: "",
//   StatusCode: 0
// }
